module.exports = __webpack_public_path__ + "img/icon-right.1b644d83.svg";